import { useEffect, useState } from 'react';
import { MetricOption } from '../../interfaces/MetricsInterface';
import { getMetricsInfo, getSurveyMetricsInfo, metricOptionValue } from '../../services/metricsService';
import useErrorModal from './useErrorModal';

const useMetricsCatalog = (eoaId: string, accessToken: string): MetricOption[] => {
  const { handleOpen: handleOpenErrorModal } = useErrorModal();
  const [metricOptions, setMetricOptions] = useState<MetricOption[]>([]);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const [data, survey] = await Promise.all([
          getMetricsInfo(eoaId, accessToken),
          getSurveyMetricsInfo(eoaId, accessToken),
        ]);
        if (cancelled) return;
        setMetricOptions([
          ...data.metrics.map(
            (entry): MetricOption => ({ value: metricOptionValue('data', entry.name), label: entry.display_name })
          ),
          ...survey.metrics.map(
            (entry): MetricOption => ({ value: metricOptionValue('survey', entry.name), label: entry.display_name })
          ),
        ]);
      } catch (error) {
        if (!cancelled) handleOpenErrorModal('Failed to load metrics', error as Error);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [eoaId, accessToken, handleOpenErrorModal]);

  return metricOptions;
};

export default useMetricsCatalog;
